import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext, API } from '@/App';
import { Loader2 } from 'lucide-react';
import { showToast } from '@/lib/custom-toast';
import axios from 'axios';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    
    const handleCallback = async () => {
      // Get authorization code from URL
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const error = params.get('error');
      
      if (error) {
        showToast.error('Autenticación con Google cancelada');
        navigate('/');
        return;
      }
      
      if (!code) {
        showToast.error('No se recibió código de Google');
        navigate('/');
        return;
      }
      
      hasRun.current = true;
      try {
        // Send code to backend
        const response = await axios.post(`${API}/auth/google/callback`, { code });
        
        // Login user
        login(response.data.access_token, response.data.user);
        
        showToast.success('¡Inicio de sesión exitoso!');
        
        // Redirect to dashboard
        navigate('/dashboard');
        
      } catch (error) {
        hasRun.current = false;
        console.error('Google OAuth error:', error);
        showToast.error(error.response?.data?.detail || 'Error al autenticar con Google');
        navigate('/');
      }
    };
    
    handleCallback();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-lg text-slate-600">Autenticando con Google...</p>
        <p className="text-sm text-slate-500 mt-2">Por favor espera un momento</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
